<template>

	<header class="title-header">
		<div class="backdrop">
			<h2>
				<span class="subtitle">{{ subtitle }}</span>
				<span class="title">{{ title }}</span>
			</h2>
		</div>
	</header>
	
</template>

<script>
	
	export default {
		name: 'TitleHeader',
		
		props: ['subtitle', 'title']
	}
	
</script>